import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';



export const couponsListService = params => axios.get(API.COUPONS_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const getCouponById = params => axios.get(API.COUPONS_BY_ID + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


export const couponsCreateService = params => axios.post(API.CREATE_COUPONS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const updateUserCoupon = params => axios.post(API.ADD_USER_COUPONS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});
export const updateTax = params => axios.post(API.UPDATE_TAX, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const couponsDeleteService = params => axios.post(API.DELETE_COUPONS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const couponsUpdateService = params => axios.post(API.UPDATE_COUPONS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


